import { useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { SegmentControl } from '@blade/ui-kit'
import { CurrencyNetworkIcon } from '@root/entities/currency/ui/currency-icon/currency-network-icon'
import { selectedNetworkAtom } from '@root/entities/network'
import {
  USER_TRADING_ANALYTICS_PRICE_TYPES,
  UserTradingAnalyticsPriceType,
} from '@root/features/user/user-trading-analytics/models'

import type { Network } from '@root/entities/network'

type Props = {
  priceType: UserTradingAnalyticsPriceType
  onPriceTypeChange: (priceType: UserTradingAnalyticsPriceType) => void
}

const PRICE_TYPE_LABEL_MAP: Record<
  UserTradingAnalyticsPriceType,
  (args: { network: Network.Network; disabled: boolean }) => React.ReactNode
> = {
  [UserTradingAnalyticsPriceType.USD]: () => <Usd>$</Usd>,
  [UserTradingAnalyticsPriceType.NATIVE]: ({ network, disabled }) => {
    return (
      <CurrencyNetworkIcon network={network} size={16} disabled={disabled} />
    )
  },
}

const Usd = styled.span`
  display: inline-block;
  width: 16px;
`

export const StatisticsPriceTypeTabs: React.FC<Props> = ({
  priceType,
  onPriceTypeChange,
}) => {
  const [selectedNetwork] = useAtom(selectedNetworkAtom)

  return (
    <SegmentControlStyled value={priceType} onChange={onPriceTypeChange}>
      {USER_TRADING_ANALYTICS_PRICE_TYPES.map((period) => (
        <SegmentControl.Item key={period} value={period}>
          {PRICE_TYPE_LABEL_MAP[period]({
            network: selectedNetwork,
            disabled: priceType !== UserTradingAnalyticsPriceType.NATIVE,
          })}
        </SegmentControl.Item>
      ))}
    </SegmentControlStyled>
  )
}

const SegmentControlStyled = styled(
  SegmentControl<UserTradingAnalyticsPriceType>,
)`
  background: var(--background-1);
`
